export default "__VITE_ASSET__B9Cr46cK__"